import React, { useEffect } from 'react';
import DateField, { formatDateValue, parseDateValue } from '../ui/DateField';

export const parseCriteriaDateValue = parseDateValue;
export const formatCriteriaDateValue = formatDateValue;

/**
 * Calendar value input for date / timestamp segment criteria.
 * Empty values default to today.
 * @param {'date' | 'timestamp'} family
 */
const CriteriaDateValue = ({
  value,
  onChange,
  family = 'date',
  className = 'criteria-value',
  placeholder,
}) => {
  useEffect(() => {
    if (!String(value || '').trim()) {
      onChange(formatDateValue(new Date(), family));
    }
    // Seed empty fields to today on mount / when column family changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- avoid re-seeding on every parent render
  }, [family]);

  return (
    <DateField
      value={value}
      onChange={onChange}
      family={family}
      className={className}
      placeholder={placeholder}
    />
  );
};

export default CriteriaDateValue;
